export default "__VITE_ASSET__6b46556b__"